"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const core_ui_1 = require("@sierralabs/core-ui");
const useCreateQueryGroup_1 = require("../hooks/useCreateQueryGroup");
const CreateQueryGroupDialog = ({ open, onCancel, onCreated }) => {
    const [formValues, setFormValues] = (0, react_1.useState)({});
    const { createdQueryGroup, isCreating, error, createQueryGroup } = (0, useCreateQueryGroup_1.useCreateQueryGroup)();
    const onCreatedRef = (0, react_1.useRef)(onCreated);
    (0, react_1.useEffect)(() => {
        var _a;
        if (createdQueryGroup) {
            (_a = onCreatedRef.current) === null || _a === void 0 ? void 0 : _a.call(onCreatedRef, createdQueryGroup);
        }
    }, [createdQueryGroup]);
    return (react_1.default.createElement(core_1.Dialog, { fullWidth: true, open: open, onClose: onCancel },
        react_1.default.createElement(core_1.DialogTitle, null, "Create Entity"),
        react_1.default.createElement("form", { onSubmit: event => {
                event.preventDefault();
                if (formValues.name) {
                    createQueryGroup(formValues);
                }
            } },
            react_1.default.createElement(core_1.DialogContent, null,
                react_1.default.createElement(core_ui_1.ConfigFieldControl, null,
                    react_1.default.createElement(core_1.TextField, { autoFocus: true, fullWidth: true, size: 'small', variant: 'outlined', label: 'Query Group Name', value: formValues.name || '', onChange: event => setFormValues(Object.assign(Object.assign({}, formValues), { name: event.target.value })) }))),
            react_1.default.createElement(core_1.DialogActions, null,
                react_1.default.createElement(core_1.Button, { onClick: onCancel }, "Cancel"),
                react_1.default.createElement(core_1.Button, { variant: 'contained', type: 'submit', disabled: !formValues.name, endIcon: isCreating && react_1.default.createElement(core_1.CircularProgress, { size: 20 }) }, "Submit"))),
        error && (react_1.default.createElement(core_ui_1.AppSnackbar, { open: true, severity: 'error' }, error.message || 'An error occurred'))));
};
exports.default = CreateQueryGroupDialog;
//# sourceMappingURL=CreateQueryGroupDialog.js.map